import { FlyoutLink } from "@app/shared/Flyouts";
import { FC, RefObject } from "react";
import { ZipJobsFlyout } from "@app/projects/network-assessment/ZipJobsFlyout";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface ZipJobsPanelContentLinkProps {
    inline?: boolean;
    projectId: number;
    projectName: string;
    triggerElementOverride?: RefObject<HTMLButtonElement>;
}

export const ZipJobsPanelContentLink: FC<ZipJobsPanelContentLinkProps> = (props: ZipJobsPanelContentLinkProps) => {
    return (
        <FlyoutLink
            classNames={`${props.inline ? "d-inline-block" : "col-12"} action-menu-item side-panel-link fw-normal`}
            content={{
                body: (
                    <ZipJobsFlyout projectId={props.projectId} />
                ),
                title: `Jobs - ${props.projectName}`,
            }}
            size="60"
            testId="jobs-panel-content-link__flyout"
            triggerElementOverride={props.triggerElementOverride}
        >
          <span className="project-action-button"><QesIcon iconName={QesIcons.TerminalBrowser} isDecorative />Jobs</span>
        </FlyoutLink>
    );
}

